// Which planner rows are expanded, and which disclosures inside them are open.
//
// Shared because two controllers need the same keys: the row owns its own state
// (it has to restore itself when *it* is the thing Turbo replaced), and the list
// closes every row when a drag starts. Both read and write the same two lists,
// so the key strings live in one place rather than being spelled twice.
//
// Keyed by round id, never by index, so the right row reopens after the list
// reorders. localStorage rather than a controller value because every save in
// the planner replaces markup — see .claude/rules/persist-ui-state.md.
const read = (key) => {
  try {
    const parsed = JSON.parse(localStorage.getItem(key))
    return Array.isArray(parsed) ? parsed : []
  } catch (_) {
    return []
  }
}

const write = (key, values) => {
  try {
    localStorage.setItem(key, JSON.stringify(values))
  } catch (_) {
    /* private mode etc. — the state is just not sticky */
  }
}

export const openRowsKey = (seasonId) => `season-plan:${seasonId}:open-rows`
export const openMoreKey = (seasonId) => `season-plan:${seasonId}:open-more`

export const openRows = (seasonId) => read(openRowsKey(seasonId))
export const setOpenRows = (seasonId, ids) => write(openRowsKey(seasonId), ids)

export const openDisclosures = (seasonId) => read(openMoreKey(seasonId))
export const setOpenDisclosures = (seasonId, keys) =>
  write(openMoreKey(seasonId), keys)

// Add or remove one entry from a stored list, and hand back the new list.
export const toggleIn = (list, value, present) => {
  const next = new Set(list)
  present ? next.add(value) : next.delete(value)
  return [...next]
}
